module.exports = __webpack_public_path__ + "static/img/8.f0b836f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/2/zh/8.png
// module id = uKFt
// module chunks = 0